import React from 'react';
import styled from '@emotion/styled';
import { Box, Container, Grid, useMediaQuery, Typography, Button, Divider } from '@mui/material';
import logo from '../../../../assets/logo.png';
import tgfooter from '../../../../assets/tgfooter.png';
import xfooter from '../../../../assets/xfooter.png';
import { Coingecko, CoinMarketCap, dexScreenerLink, TermsofUse, uniSwapLink } from '../../../../links';
import Paragraph from '../../../Components/Paragraph';
import footerlayerbg from '../../../../assets/footerlayerbg.png';
import blurlayer from '../../../../assets/blurlayer.png';
import playstore from '../../../../assets/playstore.png';
import apple from '../../../../assets/apple.png';

const Wrapper = styled(Box)`
  padding: 300px 0px 0px 0px;
  position: relative;
  z-index: 2;
  /* overflow: hidden; */
`;

const Firstdiv = styled('div')`
  @media (max-width: 899px) {
    justify-content: center;
    text-align: center;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
`;

const Mainimg = styled('img')`
  width: 100%;
  max-width: 230px;
  height: auto;
  @media (max-width: 899px) {
    margin-bottom: 20px;
  }
`;

const LayerImage = styled.img`
 position: absolute;
    top: -437px;
    left: 0;
    width: 100%;
    height: -webkit-fill-available;
    pointer-events: none;
    z-index: -1;
`;

const BlurLayer = styled(Grid)`
  position: relative;
  z-index: 5;
  background: url(${blurlayer}) no-repeat center;
  background-size: cover; 
  background-position: center; 
  padding: 40px 20px 20px 20px;
  
  @media (max-width: 600px) {
    padding: 30px 15px 15px 15px;
    background-size: cover; 
    background-position: center center; 
  }
  
  @media (max-width: 899px) {
    background-size: cover;
    background-position: center;
  }
`;

const SectionTitle = styled(Typography)`
  margin-bottom: 20px;
  color: #fff;
  font-size: 18px;
  font-family: SemiBold !important;
  @media (max-width: 600px) {
    font-size: 16px;
    margin-bottom: 15px;
  }
`;

const FooterLink = styled(Typography)`
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 17px;
  transition: color 0.2s ease;

  &:hover {
    color: #fff;
  }
  
  @media (max-width: 600px) {
    font-size: 15px;
    margin-bottom: 10px;
  }
`;

const SocialIcons = styled(Box)`
  display: flex;
  gap: 15px;
  
  @media (max-width: 600px) {
    gap: 10px;
  }
`;

const SocialIcon = styled('img')`
  width: 100%;
  max-width: 40px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
  
  @media (max-width: 600px) {
    max-width: 35px;
  }
`;

const ButtonBlack = styled(Button)`
  background-color: #000;
  color: #fff;
  text-transform: capitalize;
  font-size: 18px;
  font-weight: 600;
  border-radius: 10px;
  padding: 8px 15px;
  gap: 10px;
  
  &:hover {
    background-color: #000;
  }
  
  @media (max-width: 600px) {
    font-size: 16px;
    padding: 6px 12px;
  }
`;

const TextWrap = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.1;
`;

const SmallText = styled.span`
  font-size: 11px;
  margin-bottom: 2px;
`;

const BigText = styled.span`
  font-size: 18px;
  font-weight: 600;
  
  @media (max-width: 600px) {
    font-size: 16px;
  }
`;

const FooterCYA = () => {
  const isMobile = useMediaQuery('(max-width:600px)');

  return (
    <>
    <Wrapper>
      {/* LayerImage now displays on all screen sizes */}
      <LayerImage src={footerlayerbg} alt="Layer Background" />
      <Box sx={{ position: "relative", zIndex: 3 }}>
        <BlurLayer>
          <Container maxWidth="xl" sx={{ position: "relative", zIndex: 3 }}>
            {/* Main Footer Content */}
            <Grid container style={{justifyContent:'space-between',marginTop:'20px'}}>
              {/* Logo and Description Section */}
              <Grid item xs={12} md={5}>
                <Firstdiv>
                  <Mainimg src={logo} alt="logo" draggable="false" />
                  <Paragraph style={{marginTop:'20px',maxWidth:'410px',marginBottom:'20px'}}>
                    ShadowNodeVPN is a decentralized, community-powered VPN that protects users' online activity with anonymous, censorship-resistant technology.
                  </Paragraph>
                  <Box sx={{display:'flex',gap:'10px', flexWrap: isMobile ? 'wrap' : 'nowrap', justifyContent: isMobile ? 'center' : 'flex-start'}}>
                    <ButtonBlack>
                      <img src={playstore} style={{width:'100%',maxWidth:'23px',height:'auto'}}/> 
                      Google Play
                    </ButtonBlack>
                    <ButtonBlack>
                      <img src={apple} style={{ width: '23px', height: 'auto' }} />
                      <TextWrap>
                        <SmallText>Available on the</SmallText>
                        <BigText>App Store</BigText>
                      </TextWrap>
                    </ButtonBlack>
                  </Box>
                  <Paragraph style={{marginTop:'40px',maxWidth:'400px'}}>
                    You can email info@shadownode.org to provide feedback for support requests.
                  </Paragraph>
                </Firstdiv>
              </Grid>

              {/* Platform Links */}
              <Grid item xs={6} sm={4} md={1.8}>
                             <a href='https://remote.shadownode.org/window/ShadowNodeVPN_Windows-free.exe' target='blank' >  <FooterLink >VPN for Windows</FooterLink></a>
               <a href='https://remote.shadownode.org/window/Shadow-Node-VPN_Premium_Setup-1.0.0.exe' target='blank'> <FooterLink>VPN for Windows Premium</FooterLink></a>
                {/* <FooterLink>VPN for macOS</FooterLink> */}
               <a href='https://play.google.com/store/apps/details?id=com.svpn.freeshadownode' target='blank'>  <FooterLink>VPN for Android</FooterLink></a>
                <a href='https://play.google.com/store/apps/details?id=com.shadownode.svpn' target='blank'> <FooterLink>VPN for Android Premium</FooterLink></a>
                <a href='https://apps.apple.com/pk/app/shadow-node-dvpn-lite/id6680189108' target='blank'> <FooterLink>VPN for iOS</FooterLink></a>
               <a href='https://apps.apple.com/pk/app/shadow-node-dvpn-lite/id6680189108' target='blank'> <FooterLink>VPN for iOS Premium</FooterLink></a>
                <a href='https://remote.shadownode.org/ShadowNodeVPN-1.0.0-linux-amd64.deb' target='blank'> <FooterLink>VPN for Ubuntu</FooterLink></a>
               <a href='https://remote.shadownode.org/shadow_node_vpn_premium.deb' target='blank'> <FooterLink>VPN for Ubuntu Premium</FooterLink></a>
               <a href='https://play.google.com/store/apps/details?id=com.svpn.freeshadownode' target='blank'> <FooterLink>VPN for Android TV</FooterLink></a>
               <a href='https://play.google.com/store/apps/details?id=com.shadownode.svpn' target='blank'> <FooterLink>VPN for Android TV Premium</FooterLink></a>
              </Grid>

              {/* Company Links */}
              <Grid item xs={6} sm={4} md={1}>
                <SectionTitle>Company</SectionTitle>
                <FooterLink>About</FooterLink>
                <FooterLink>Whitepaper</FooterLink>
                <FooterLink>Blog</FooterLink>
              </Grid>

              {/* SSVPN Token Links */}
              <Grid item xs={6} sm={4} md={1}>
                <SectionTitle>$SVPN Token</SectionTitle>
                <FooterLink>Etherscan</FooterLink>
                <FooterLink>Staking</FooterLink>
                <FooterLink>Uniswap</FooterLink>
                <FooterLink>MEXC</FooterLink>
                <FooterLink>CoinMarketCap</FooterLink>
                <FooterLink>CoinGecko</FooterLink>
                <FooterLink>DexTools</FooterLink>
                <FooterLink>DexScreener</FooterLink>
              </Grid>

              {/* Legal Links */}
              <Grid item xs={6} sm={4} md={1}>
                <SectionTitle>Legal</SectionTitle>
                <FooterLink>Privacy Policy</FooterLink>
                <FooterLink>Terms of Service</FooterLink>
              </Grid>
            </Grid>
            
            <Divider sx={{ 
              marginInline: isMobile ? '-30px' : '-38px', 
              borderBottomWidth: '1px',
              borderColor: '#2222226a',
              marginTop:'20px',
              marginBottom:"25px"
            }} />
            
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexDirection: isMobile ? 'column' : 'row',
              gap: isMobile ? '15px' : '0'
            }}>
              <Paragraph sx={{display:'flex', alignItems:'center'}}>
                © 2025 Shadow Node
              </Paragraph>

              <SocialIcons sx={{display:'flex', alignItems:'center', gap:'10px'}}>
                <SocialIcon src={xfooter} alt="X (Twitter)" />
                <SocialIcon src={tgfooter} alt="Telegram" />
              </SocialIcons>
            </Box>
          </Container>
        </BlurLayer>
      </Box>
    </Wrapper>
    </>
  );
};

export default FooterCYA;